import classNames from 'classnames';
import React, { FC } from 'react';
import { Container } from 'react-bootstrap';

import TabItem, { TabItemProps } from './TabItem';

export interface TabProps {
  items: TabItemProps[];
  activeKey: string;
}

const Tab: FC<TabProps> = (props) => {
  const TabContainerBackground = () => {
    const firstActive = props.items[0] && props.activeKey === props.items[0].title;
    const lastActive =
      props.items[props.items.length - 1] &&
      props.activeKey === props.items[props.items.length - 1].title;
    return (
      <div
        className={classNames(
          'oejr-tab-container-bg',
          firstActive && 'oejr-tab-first-active',
          lastActive && 'oejr-tab-last-active',
        )}
      >
        <div className="oejr-tab-container-bg-left" />
        <div className="oejr-tab-container-bg-right" />
      </div>
    );
  };

  return (
    <div className="oejr-tab">
      <Container>
        <TabContainerBackground />
        {props.items.map((item, key) => (
          <TabItem {...item} active={item.title === props.activeKey} key={key} />
        ))}
      </Container>
    </div>
  );
};

export default Tab;
